import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowsLeftRightToLine,
  faAward,
  faBars,
  faBirthdayCake,
  faCalendarCheck,
  faCalendarDays,
  faCamera,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faCircleUser,
  faCircleXmark,
  faDesktop,
  faEnvelope,
  faFilter,
  faLink,
  faLocationDot,
  faMagnifyingGlass,
  faMapMarkerAlt,
  faMoon,
  faPencil,
  faPhone,
  faPrint,
  faRightFromBracket,
  faShareNodes,
  faShieldAlt,
  faSliders,
  faSun,
  faTable,
  faTrash,
  faTriangleExclamation,
  faUpRightFromSquare,
  faUser,
  faUserDoctor,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

import {
  faFacebook,
  faLinkedin,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowsLeftRightToLine,
  faAward,
  faBars,
  faBirthdayCake,
  faCalendarCheck,
  faCalendarDays,
  faCamera,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faCircleUser,
  faCircleXmark,
  faDesktop,
  faEnvelope,
  faFacebook,
  faFilter,
  faLink,
  faLinkedin,
  faLocationDot,
  faMagnifyingGlass,
  faMapMarkerAlt,
  faMoon,
  faPencil,
  faPhone,
  faPrint,
  faRightFromBracket,
  faShareNodes,
  faShieldAlt,
  faSliders,
  faSun,
  faTable,
  faTrash,
  faTriangleExclamation,
  faUpRightFromSquare,
  faUser,
  faUserDoctor,
  faXmark,
  faXTwitter,
  faYoutube
)
